import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';


class ShippingFeesRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      total: initialValues.total || 4000,
      supplier: initialValues.supplier || 'all',
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      regions: _.filter(this.state.regions),
      kind: 'shipping_fees',
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { total, supplier, regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          value={supplier}
          onChange={supplier_id => this.setState({ supplier: supplier_id })}
        />
        <InlineInputNumber
          label='Shipping Fees'
          description='Monthly total of shipping fees'
          displayFormat='dollar'
          value={total}
          onChange={value => this.setState({ total: value })}
        />
      </RuleForm>
    );
  }
}

ShippingFeesRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

ShippingFeesRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default ShippingFeesRule;
